import { logoNameMapper } from "./logoNameMapper.js";
import logos from "./logos.js";

/**
 * Return the logo file depending on the given provider name
 * @param providerName
 */
export function logoFileMapper(providerName) {
  const name = logoNameMapper(providerName);
  return {
    centered: logos[name.centered],
    cropped: logos[name.cropped]
  };
}